import clsx from 'clsx';

interface Props {
  className?: string;
  /** Quick preset: "line" for single-line text, "block" for card-sized */
  shape?: 'line' | 'block' | 'circle';
  width?: string;
  height?: string;
}

export function Skeleton({ className, shape = 'line', width, height }: Props) {
  return (
    <span
      role="presentation"
      aria-hidden
      className={clsx(
        'pb-skeleton block',
        shape === 'line' && 'h-4',
        shape === 'block' && 'h-24 rounded-pb-lg',
        shape === 'circle' && 'rounded-full',
        className,
      )}
      style={{ width, height }}
    />
  );
}
